import styled from 'styled-components'

export const _Flex = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: nowrap;
  justify-content: flex-start;
  ${({ center }) =>
    (center
      ? `
        justify-content: center;
        align-items: center;
      `
      : '')}
  ${({ justify }) =>
    (justify
      ? `justify-content: ${
        justify === 'start'
          ? 'flex-start'
          : justify === 'end'
            ? 'flex-end'
            : justify === 'between'
              ? 'space-between'
              : justify === 'around'
                ? 'space-around'
                : justify === 'center'
                  ? 'center'
                  : ''
      };
        `
      : '')}

  ${({ align }) =>
    (align
      ? `align-items: ${
        align === 'start' ? 'flex-start' : align === 'end' ? 'flex-end' : align === 'center' ? 'center' : ''
      };
        `
      : '')}

  ${({ noWrap }) => (noWrap ? 'flex-wrap: nowrap;' : '')}

  ${({ direction }) =>
    (direction
      ? `flex-direction: ${direction === 'col' ? 'column' : ''};
        `
      : '')}
  ${({ wrap }) => (wrap ? 'flex-wrap: wrap;' : 'flex-wrap: nowrap;')}
  ${({ gap }) => `gap: ${gap}` || 0}
`
